import ToastProvider from '@/components/base/ToastProvider';
import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import TickerBar from '@/pages/home/components/TickerBar';
import EntryStrip from '@/pages/home/components/EntryStrip';
import RankingSection from '@/pages/home/components/RankingSection';
import CollectionSection from '@/pages/home/components/CollectionSection';
import TopicWall from '@/pages/home/components/TopicWall';
import TrustSection from '@/pages/home/components/TrustSection';
import SubmitSection from '@/pages/home/components/SubmitSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <ToastProvider>
      <div className="flex min-h-screen w-full flex-col bg-background-50">
        <Header />
        <main className="flex-1">
          <Hero />
          <TickerBar />
          <EntryStrip />
          <RankingSection />
          <CollectionSection />
          <TopicWall />
          <TrustSection />
          <SubmitSection />
        </main>
        <Footer />
      </div>
    </ToastProvider>
  );
}